import { Flex, Shimmer } from '@/_components';
import { FC } from 'react';
import type { NotificationItemLoadingProps } from './NotificationItemLoading.types';

export const NotificationItemLoading: FC<NotificationItemLoadingProps> = () => {
  return (
    <Flex gap={6} padding={8} isBetween={true} isColumn={false}>
      <Flex gap={6}>
        <Flex isColumn={true} gap={4}>
          <Flex gap={4}>
            <Shimmer width={360} height={16} />
            <Shimmer width={80} height={16} />
          </Flex>
          <Shimmer width={120} height={12} />
        </Flex>
      </Flex>
    </Flex>
  );
};
